// @flow
import * as React from 'react';
import type { Element, ChildrenArray } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { Text } from '../Text.js';
import { List } from '../List.js';
import { EngageNoteCollapsibleInternal } from './EngageNoteCollapsibleInternal.js';
import { productColor } from '../designSystem.js';
export function EANPurposefulQuestionsPanel(props: {|
  children: ChildrenArray<Element<typeof Text> | Element<typeof List>>,
|}) {
  const { failedValidation } = usePropsValidation(
    props,
    EANPurposefulQuestionsPanel,
  );
  if (failedValidation) return null;

  const children = React.Children.toArray(props.children);
  return (
    <EngageNoteCollapsibleInternal title="Purposeful questions">
      {children.map((child, i) => (
        <React.Fragment key={i}>
          <div style={{ color: productColor.shuttleGrey }}>{child}</div>
          {i !== children.length - 1 && <div style={{ height: 16 }} />}
        </React.Fragment>
      ))}
    </EngageNoteCollapsibleInternal>
  );
}
EANPurposefulQuestionsPanel.spec = {
  children: t.childrenArray(
    t.unionOfTypes(t.elementType(Text), t.elementType(List)),
  ),
};
